<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}} Type</h4>
      </div>

      <div class="cell shrink">
        <router-link :to="{ name: 'InstillingerList' }" class="button primary transparent">Gå tilbake</router-link>
      </div>
    </div>

    <router-link :to="{ name: name + 'TypeAdd'}" class="button action fixed right">
      Ny {{name}} Type
    </router-link>

    <TheLoader :active="loading"/>

    <table v-if="!loading && items.length > 0" class="large fixed clickable" style="width: 100%">
      <thead>
        <tr>
          <th>#</th>
          <th>Kode</th>
          <th>Info</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" v-bind:key="item.id" @click="editItem(item)">
          <td>{{item.id}}</td>
          <td>{{item.code}}</td>
          <td>{{item.info}}</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination-container"  v-if="pages > 1">
      <paginate v-model="page"
        :page-count="pages"
        :page-range="11"
        :click-handler="setPage"
        :container-class="'pagination'"
        :prev-text="paginationArrow"
        :next-text="paginationArrow"
        :prev-class="'prev'"
        :next-class="'next'"
        >
      </paginate>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      page: 1,
      pages: 1,
      items: [],
      loading: true
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    this.page = to.query.page ? parseInt(to.query.page) : 1

    this.fetch(next)
  },
  created () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
    this.fetch()
  },
  methods: {
    fetch: function (callback) {
      this.loading = true

      let service = InstillingerService(this.servicename)

      service.index(this.page)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
        })
    },
    setPage: function (pageNum) {
      this.$router.push({ name: this.$route.name, query: {page: pageNum} })
    },
    editItem: function (item) {
      this.$router.push({name: this.name + 'TypeEdit', params: {id: item.id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerTypeList.vue